import { Injectable } from "@angular/core";
import { UserInfo } from "src/app/api/models";

export const STORAGE_KEYS = {
  AUTH: "auth-token",
  USER: "auth-user",
  PENDING_2FA: "pending-2fa",
  PENDING_2FA_SETUP: "pending-2fa-setup",
} as const;

export const TOKEN_STORAGE_KEYS = {
  AUTH: STORAGE_KEYS.AUTH,
  PENDING_2FA: STORAGE_KEYS.PENDING_2FA,
  PENDING_2FA_SETUP: STORAGE_KEYS.PENDING_2FA_SETUP,
} as const;

export type TokenKind =
  (typeof TOKEN_STORAGE_KEYS)[keyof typeof TOKEN_STORAGE_KEYS];

@Injectable({
  providedIn: "root",
})
export class TokenStorageService {
  constructor() {}

  public clearStorage(): void {
    Object.values(STORAGE_KEYS).forEach((key) => {
      window.localStorage.removeItem(key);
    });
  }

  public saveToken(token: string, kind: TokenKind): void {
    window.localStorage.removeItem(kind);
    window.localStorage.setItem(kind, token);

    if (kind === TOKEN_STORAGE_KEYS.AUTH) {
      window.localStorage.removeItem(TOKEN_STORAGE_KEYS.PENDING_2FA);
      window.localStorage.removeItem(TOKEN_STORAGE_KEYS.PENDING_2FA_SETUP);
    }
  }

  public getToken(kind: TokenKind): string | null {
    return window.localStorage.getItem(kind);
  }

  public clearToken(kind: TokenKind): void {
    window.localStorage.removeItem(kind);
  }

  public saveUser(user: UserInfo): void {
    window.localStorage.removeItem(STORAGE_KEYS.USER);
    window.localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
  }

  public getUser(): UserInfo | undefined {
    const user = window.localStorage.getItem(STORAGE_KEYS.USER);
    return user ? (JSON.parse(user) as UserInfo) : undefined;
  }
}
